<template>
    <div class="flex flex-wrap gap-2">
        <div
            class="flex rounded-sm bg-white"
            v-for="(item, index) in lineItems"
            :key="item.id"
            :class="{ 'hidden md:block': index >= 2 }">
            <ShopwareImg
                v-if="item.cover"
                class="h-[150px] w-[100px] lg:h-[200px] lg:w-[150px] rounded-sm object-cover"
                :alt="item.cover?.alt ?? ''"
                :src="item.cover?.url"
                :width="150" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    // The order listing request already loads lineItems.cover, so the order object is rendered
    // directly. Re-fetching per order (the previous useOrderDetails(id) approach) caused an extra
    // /store-api/order request for every row — and returned nothing for TritonX in-store orders,
    // which only exist in the merged listing response and cannot be looked up by id.
    const props = defineProps({
        order: Object,
    });

    const lineItems = computed(() => props.order?.lineItems?.filter(item => item?.cover?.url).slice(0, 4) ?? []);
</script>
